export const initialState = {
    priceOffer:'',
    loading: false,
    claim:'',
    claimParts:[],
    offerLoading:false,
    policies:[],
    parts:[]
};
